import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
   
    
}
const mutations={
   
    
    setLoginData(state,value){
        
           
     
        post(urls.admin.login.setVerify,value).then((result)=>{
         
          state.result=result
          if(result.code==200){
         
           let token_params = { token: result.token };
            localStorage.setItem("sh_admin_user_data", JSON.stringify(token_params));
          }
          
          
       
        
       
           
        });
        
    }

}
const  actions={
    setLoginDataAction(context,value){
       
        context.commit("setLoginData",value)
       
    },
  
    
   

}

export default {state,mutations,actions}